import { colors } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { createUseStyles } from 'react-jss';

const styles = {
  tableWrapper: {
    border: `0.1rem solid ${colors.neutral[300]}`,
    borderRadius: '1rem',
    marginTop: '2rem',
    marginBottom: '5rem',
    overflow: 'hidden',
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    width: '5rem',
    backgroundColor: TABLE_HEADER_BG_COLOR,
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
